// extracted by mini-css-extract-plugin
export var cardHeader = "_tk-0";
export var reorderHandle = "_tk-3";
export var titleArea = "_tk-1";
export var titleAreaWithHandle = "_tk-2";